exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-scroll-board{position:relative;width:100%;height:100%;color:#fff}.dv-scroll-board .text{padding:0 10px;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dv-scroll-board .header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;font-size:15px}.dv-scroll-board .header .header-item{padding:0 10px;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:all .3s}.dv-scroll-board .rows{overflow:hidden}.dv-scroll-board .rows .row-item{display:-ms-flexbox;display:flex;font-size:14px;transition:all .3s}.dv-scroll-board .rows .ceil{padding:0 10px;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dv-scroll-board .rows .index{border-radius:3px;padding:0 3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/scrollBoard/src/main.css
// module id = 1102
// module chunks = 45